export const hasPartnerCampaignIds = (linearTv: LinearTv[]): boolean => {
  const incomingIds = linearTv.filter(mapping =>
    mapping?.partner_campaigns_ids.some(id => id.length > 0)
  );

  return incomingIds.length > 0;
};
